<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="add"
          >添加作息表</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column
            label="序号"
            prop="seheduleTypeId"
            width="70"
            align="center"
          >
            <template v-slot="scope">
              <div>{{ scope.$index + 1 }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="typeName" label="分类名称" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template v-slot="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="edit(scope.row.scheduleTypeId)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="del(scope.row.scheduleTypeId)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <add-or-edit
      :addOrEdit="addOrEdit"
      :operateResize="operateResize"
      :scheduleTypeId="scheduleTypeId"
      @getList="getList"
    ></add-or-edit>
  </div>
</template>

<script>
import RestBroadcastManagement from "@/components/RestBroadcastManagement";
import AddOrEdit from "./components/RestBroadcastSettingsAddOrEdit.vue";
export default {
  name: "",
  components: {
    RestBroadcastManagement,
    AddOrEdit
  },
  props: {},
  data() {
    return {
      // 响应数据
      responseData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      },
      operateResize: 0,
      addOrEdit: 0,
      scheduleTypeId: 0
    };
  },
  created() {
    this.getList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    add() {
      this.scheduleTypeId = 0;
      this.addOrEdit = 0;
      this.operateResize++;
    },
    edit(id) {
      this.scheduleTypeId = id;
      this.addOrEdit = 1;
      this.operateResize++;
    },
    del(id) {
      // console.log(id);
      this.$confirm("此操作将永久删除该作息表, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delBroadcastRest(id);
        })
        .catch(() => {});
    },
    async delBroadcastRest(id) {
      let req = {
        scheduleTypeId: id
      };
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let res = await this.$Http.delBroadcastRest(req);
      // console.log(res)
      loading.close();
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getList();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getList() {
      let req = {
        schoolId: this.$store.state.schoolId
      };

      let res = await this.$Http.getBroadcastRest(req);
      // console.log(res)
      if (res.code == 200) {
        // console.log(res.data)
        this.responseData.list = res.data || [];
      } else if (res.code == 101) {
        this.responseData.list = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style scoped></style>
